var _mask, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartProportion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "ipSChartProportion0"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M16.345 5.518a20.029 20.029 0 0 0-6.487 4.34A19.938 19.938 0 0 0 4 24c0 11.046 8.954 20 20 20v0a19.937 19.937 0 0 0 14.142-5.858a20.026 20.026 0 0 0 4.34-6.487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 24h20c0-11.046-8.954-20-20-20v20Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h48v48H0z",
    mask: "url(#ipSChartProportion0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartProportion);
export default __webpack_public_path__ + "static/media/chart-proportion.ab4239a071363b05522965755bf22cca.svg";
export { ForwardRef as ReactComponent };